import React from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import {getWalkTimeValue} from 'modules/wineshops-list/helpers';
import {IExpressOrder} from 'plugins/modules/filter/types';

interface IWineryLocationProps {
    address: IExpressOrder['address'];
    metroStations: IExpressOrder['metroStations'];
    geoposition: IExpressOrder['geoposition'];
}

export const WineryLocation = (props: IWineryLocationProps) => {
    const {address, metroStations, geoposition} = props;

    return (
        <div className={style.container}>
            <Icon icon={'clock'} width={20} height={20} className={style.wineryRowIcon} />
            <div>
                <div>
                    <Typography variant={'label-14-r'}>{address}</Typography>
                </div>
                {Boolean(metroStations.length) && (
                    <div className={style.metroContainer}>
                        {metroStations.map((station) => {
                            const {name, hexColor} = station;
                            const time = getWalkTimeValue(station, geoposition);

                            return (
                                <div className={style.stationRow} key={name}>
                                    <div className={style.stationMark} style={{backgroundColor: `#${hexColor}`}} />
                                    <Typography variant={'label-12-r'} className={style.stationName}>
                                        {name}
                                    </Typography>
                                    <div className={style.walkingTimeContainer}>
                                        <Icon icon={'walking-human'} width={16} height={12} />
                                        <Typography variant={'label-12-r'} className={style.stationName}>
                                            {time}
                                        </Typography>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};
